import type { Plan } from '../types/types';

export function getNumericPlanFeature(
  plan: Plan | null | undefined,
  key: string,
): number | undefined {
  const value = plan?.features?.[key];

  if (value == null || value === '') {
    return undefined;
  }

  const numericValue = Number(value);

  return Number.isFinite(numericValue) ? numericValue : undefined;
}
